import clsx from "clsx";
import { useState } from "react";
import { Coordinates, NavArrow } from "./components";
import Gradient from "../Gradient";
import * as styles from "./styles";

export default function Timelapse({
    images,
    coordinates,
    caption,
    startingPosition = 0,
    gradient,
}) {
    const [currentIndex, setCurrentIndex] = useState(startingPosition);

    return (
        <div className={styles.container}>
            <div className={clsx(gradient ? "-mt-2 mb-6" : "mb-10")}>
                {gradient && <Gradient {...gradient} />}
            </div>
            <div className={styles.imgWrapper}>
                <Coordinates coordinates={coordinates} />
                <img
                    src={images[currentIndex].src}
                    alt={`Year ${images[currentIndex].year}`}
                    className="h-full w-full rounded-lg object-cover"
                />

                <div className={styles.navigation}>
                    <NavArrow
                        onClick={() =>
                            setCurrentIndex(
                                (currentIndex - 1 + images.length) %
                                    images.length,
                            )
                        }
                    />
                    {images.map((image, index) => (
                        <div
                            key={image.year}
                            className={clsx(
                                "flex cursor-pointer text-xs md:text-sm",
                                index === currentIndex
                                    ? "text-green"
                                    : "text-white/70",
                            )}
                            onClick={() => setCurrentIndex(index)}
                        >
                            {index === 0 && <IntervalDivider />}
                            {image.year}
                            <IntervalDivider />
                        </div>
                    ))}
                    <NavArrow
                        right={true}
                        onClick={() =>
                            setCurrentIndex((currentIndex + 1) % images.length)
                        }
                    />
                </div>
            </div>
            <div className={styles.caption}>{caption}</div>
        </div>
    );
}

const IntervalDivider = () => <div className="mx-2 text-white/40">|</div>;
